module.exports = __webpack_public_path__ + "img/gallery14.4baf6515.png";